import React from "react";
import { brands } from "../mock";

export default function Brands() {
  const row = [...brands, ...brands, ...brands];
  return (
    <section className="relative py-14 bg-[#F3E9DD] border-y border-[#E7D8C6] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 text-center mb-8">
        <span className="font-body text-xs tracking-luxe uppercase text-[#B0603F]">
          Ils m'ont fait confiance
        </span>
      </div>
      <div className="relative">
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#F3E9DD] to-transparent z-10" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#F3E9DD] to-transparent z-10" />
        <div className="flex whitespace-nowrap animate-marquee">
          {row.map((b, i) => (
            <span key={i} className="mx-10 inline-flex items-center gap-10">
              <span className="font-serif-display text-3xl md:text-4xl text-[#3A302A]">{b}</span>
              <span className="text-[#B0603F] text-xl">✦</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
